export const pixelTesterInitialValues = {
    pixelTesterWebsiteUrl: '',
    pixelTesterEvents: [],
};
